onComplete(function () {
	// navheader mobile

	const navHeader = document.querySelector('.nav-header');

	const updateHeaderHeight = () => {
		if (navHeader) {
			document.documentElement.style.setProperty(
				'--header-height',
				`${navHeader.offsetHeight}px`
			);
		}
	};

	if (navHeader) {
		updateHeaderHeight();

		new ResizeObserver(updateHeaderHeight).observe(navHeader);

		window.addEventListener('resize', updateHeaderHeight);
	};
});

// Postcode check "fysio aan huis".
// Toegestane (volledige) postcodes; klantlijst hier bijwerken.
// Spaties/hoofdletters maken niet uit, de check normaliseert.
const FYSIO_HOME_POSTCODES = [
	'7833 AA',
	'7833 AB',
	'7833 AC',
	'7833 AD',
	'7833 AE',
	'7833 AG',
	'7833 AH',
	'7833 AJ',
	'7833 AK',
	'7833 AL',
	'7833 AM',
	'7833 AN',
	'7833 AP',
	'7833 AR',
	'7833 BA',
	'7833 BB',
	'7833 BC',
	'7833 BD',
	'7833 BE',
	'7833 BH',
	'7833 BJ',
	'7833 BK',
	'7833 BL',
	'7833 BM',
	'7833 BN',
	'7833 BP',
	'7833 BR',
	'7833 BS',
	'7833 BT',
	'7833 BV',
	'7833 BW',
	'7833 BX',
	'7833 BZ',
	'7833 CA',
	'7833 CB',
	'7833 CC',
	'7833 CD',
	'7833 CE',
	'7833 CG',
	'7833 CH',
	'7833 CJ',
	'7833 CK',
	'7833 CL',
	'7833 CM',
	'7833 CN',
	'7833 CP',
	'7833 CR',
	'7833 CS',
	'7833 CT',
	'7833 CV',
	'7833 CW',
	'7833 CX',
	'7833 CZ',
	'7833 DA',
	'7833 DB',
	'7833 DC',
	'7833 DD',
	'7833 DE',
	'7833 DG',
	'7833 DH',
	'7833 DJ',
	'7833 DK',
	'7833 DL',
	'7833 DM',
	'7833 DN',
	'7833 DP',
	'7833 DR',
	'7833 DS',
	'7833 DT',
	'7833 DV',
	'7833 EA',
	'7833 EB',
	'7833 EC',
	'7833 ED',
	'7833 EE',
	'7833 EG',
	'7833 EH',
	'7833 EJ',
	'7833 EK',
	'7833 EL',
	'7833 EM',
	'7833 EN',
	'7833 EP',
	'7833 ER',
	'7833 ES',
	'7833 ET',
	'7833 EV',
	'7833 EW',
	'7833 EX',
	'7833 EZ',
	'7833 GA',
	'7833 GB',
	'7833 GC',
	'7833 GD',
	'7833 GE',
	'7833 GG',
	'7833 GH',
	'7833 GJ',
	'7833 GK',
	'7833 GL',
	'7833 GM',
	'7833 GN',
	'7833 GR',
	'7833 GS',
	'7833 GT',
	'7833 GV',
	'7833 GW',
	'7833 GX',
	'7833 GZ',
	'7833 HA',
	'7833 HB',
	'7833 HC',
	'7833 HD',
	'7833 HE',
	'7833 HG',
	'7833 HH',
	'7833 HJ',
	'7833 HK',
	'7833 HL',
	'7833 HM',
	'7833 HN',
	'7833 HR',
	'7833 HS',
	'7833 HT',
	'7833 HV',
	'7833 HW',
	'7833 HX',
	'7833 HZ',
	'7833 JA',
	'7833 JB',
	'7833 JC',
	'7833 JD',
	'7833 JG',
	'7833 JH',
	'7833 JJ',
	'7833 JK',
	'7833 JL',
	'7833 JM',
	'7833 JN',
	'7833 JP',
	'7833 JR',
	'7833 JS',
	'7833 JT',
	'7833 JV',
	'7833 JW',
	'7833 JX',
	'7833 JZ',
	'7833 KB',
	'7833 KC',
	'7833 KD',
	'7833 KH',
	'7833 KL',
	'7833 KM',
	'7833 KN',
	'7833 KP',
	'7833 KR',
	'7833 KS',
	'7833 KT',
	'7833 LA',
	'7833 LB',
	'7833 LC',
	'7833 LD',
	'7833 LE',
	'7833 LG',
	'7844 KA',
	'7844 KB',
	'7844 KC',
	'7844 KD',
	'7844 KE',
	'7844 KG',
	'7844 KH',
	'7844 KJ',
	'7844 KK',
	'7844 KL',
	'7844 KM',
	'7844 KN',
	'7844 KP',
	'7844 KR',
	'7844 KS',
	'7844 KT',
	'7844 KV',
	'7844 KW',
	'7844 KX',
	'7844 KZ',
	'7844 LA',
	'7844 LB',
	'7844 LC',
	'7844 LD',
	'7844 LE',
	'7844 LG',
	'7844 LH',
	'7844 LJ',
	'7844 LK',
	'7844 LL',
	'7844 LM',
	'7844 LN',
	'7844 LP',
	'7844 LR',
	'7844 LS',
	'7844 LT',
	'7844 LV',
	'7844 LW',
	'7844 LX',
	'7844 LZ',
	'7844 MA',
	'7844 MB',
	'7844 MC',
	'7844 NA',
	'7844 NB',
	'7844 NC',
	'7844 ND',
	'7844 NE',
	'7844 NG',
	'7844 NH',
	'7844 NJ',
	'7844 NK',
	'7844 NL',
	'7844 NM',
	'7844 NN',
	'7844 NP',
	'7844 NR',
	'7844 NS',
	'7844 NV',
	'7844 NW',
	'7844 NX',
	'7844 NZ',
	'7844 PA',
	'7844 PB',
	'7844 PC',
	'7844 TA',
	'7844 TB',
	'7844 TC',
	'7844 TD',
	'7844 TE',
	'7844 TG',
	'7844 TJ',
	'7844 TL',
	'7764 AA',
	'7764 AB',
	'7764 AC',
	'7764 AD',
	'7764 AE',
	'7764 AG',
	'7764 AH',
	'7764 AJ',
	'7764 AK',
	'7764 AL',
	'7764 AM',
	'7764 AN',
	'7764 AP',
	'7764 AR',
	'7764 AS',
	'7764 AT',
	'7843 TA',
	'7843 TB',
	'7843 TC',
	'7843 TE',
	'7845 TA',
	'7845 TB',
	'7845 TD',
	'7845 TE',
	'7845 TH',
	'7845 TJ',
	'7845 TK',
	'7845 TL',
	'7845 TM',
	'7845 TN',
	'7845 TP',
	'7845 TR',
	'7845 TS',
	'7756 NL',
	'7756 PC',
	'7756 PE',
	'7756 PG',
	'7756 PH',
	'7814 VC',
	'7814 VD',
	'7814 VJ',
	'7814 VK',
	'7814 VN',
	'7755 NA',
	'7755 ND',
	'7755 NE',
	'7755 NG',
	'7755 NL',
	'7755 NN',
	'7755 NP',
	'7755 NR',
	'7755 NS',
	'7755 NT',
	'7755 PH',
	'7755 PT',
];

onComplete(function () {
	const normalize = (value) => (value || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
	const allowed = FYSIO_HOME_POSTCODES.map(normalize);

	document.querySelectorAll('[data-postcode-check]').forEach(function (form) {
		const section = form.closest('.postcode-check');
		const input = form.querySelector('.postcode-check-input');
		if (!section || !input) {
			return;
		}

		form.addEventListener('submit', function (event) {
			event.preventDefault();
			const value = normalize(input.value);
			if (!value) {
				input.focus();
				return;
			}

			const state = allowed.includes(value) ? 'success' : 'fail';
			const content = section.querySelector('[data-postcode-content="' + state + '"]');
			if (content && window.modalShow) {
				// Open via het CMS-modalsysteem (zelfde als de popup-planner).
				window.modalShow.createFromElement(content, {
					class: 'postcode-modal postcode-modal--' + state,
				});
			}
		});
	});
});